import { useMemo, Fragment, Children, isValidElement } from 'react';
import { useUtils } from './useUtils.js';

/**
 * Get one child from the Array of children (Option) passed to DropdownOptionList
 * then "map" and prepare an object of value/label that DropdownOptionList will use for focus/select matters.
 */
function mapOptionValue(child) {
  const {
    props
  } = child;
  if (typeof props.value === 'string') {
    var _props$children;
    return {
      value: props.value,
      label: props.label || ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.toString())
    };
  } else {
    return props.value;
  }
}
function useOptionListData(children) {
  const {
    hasComplexOptionsChildren,
    isValidOptionElement
  } = useUtils();
  const flatItemsArray = useMemo(() => {
    /**
     * Sometime we can pass a fragment as a "wrapper"
     * In that case read the children prop of that wrapper
     */
    const childrenAsElement = children;
    const childrenIsReactFragment = (childrenAsElement === null || childrenAsElement === void 0 ? void 0 : childrenAsElement.type) === Fragment;
    const flatChildrenArray = [];
    const flatOptionsArray = [];
    Children.toArray(childrenIsReactFragment ? childrenAsElement.props.children : children).forEach(child => {
      if ( /*#__PURE__*/isValidElement(child) && isValidOptionElement(child)) {
        flatChildrenArray.push(child);
        if (hasComplexOptionsChildren(child)) {
          /**
           * Complex children
           * This children (OptionGroup) have a set of childrens (Option or MultiSelectOption) inside an array
           */
          Children.toArray(child.props.children).forEach(subChild => {
            const subChildElement = subChild;
            if (isValidOptionElement(subChildElement)) {
              flatChildrenArray.push(subChildElement);
              const {
                label: groupOptionLabel,
                value: groupOptionValue
              } = child.props;
              flatOptionsArray.push({
                ...mapOptionValue(subChildElement),
                group: {
                  label: groupOptionLabel,
                  value: groupOptionValue
                }
              });
            }
          });
        } else {
          /**
           * Single children. Treat it as usual
           */
          flatOptionsArray.push(mapOptionValue(child));
        }
      }
    });
    return {
      childrenArray: flatChildrenArray,
      optionsArray: flatOptionsArray
    };
  }, [children, hasComplexOptionsChildren, isValidOptionElement]);
  return {
    childrensArray: flatItemsArray.childrenArray,
    optionsArray: flatItemsArray.optionsArray
  };
}

export { useOptionListData };
//# sourceMappingURL=useOptionListData.js.map
